import { Button, Col, Modal, Row, Timeline } from "antd"
import Text from "antd/es/typography/Text";
import Title from "antd/es/typography/Title";
import { useCallback } from "react";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IAward } from "../../../../../interfaces";
import { awardImagesUrl } from "../../../../../services/urls";
import { convertMoedaBRDoJSNovo } from "../../../../../utils/Conversores";
import { formatCpf, formatPhone } from "../../../../../utils/Masks";

interface IProps {
    award: IAward;
    visible: boolean;
    onClose: () => void;
}

export default function ModalAwardWithWinner({
    award,
    visible,
    onClose
}: IProps) {
    const navigate = useNavigate();

    const leftCol = useCallback(() => {
        return (<div className="p-4">
            <Row gutter={[12, 12]}>
                <Col span={24} className="flex items-center justify-center">
                    {award.images.length > 0 && (
                        <img
                            src={`${awardImagesUrl}/${award.images[0].img}`}
                            alt={award.description}
                            style={{
                                width: 180,
                                height: 180,
                                objectFit: "contain",
                                borderRadius: 12,
                                padding: 10,
                            }}
                        />)}
                </Col>
                <Col span={16}>
                    <Title level={4} className="!m-0">{award.description}</Title>
                    <div className="mt-2">
                        <Text type="secondary">Valor:</Text>
                        <div>
                            <Text strong>R${convertMoedaBRDoJSNovo(award.value) ?? '—'}</Text>
                        </div>
                    </div>


                    <div className="mt-3">
                        <Text type="secondary">Bilhete vencedor:</Text>
                        <div className="flex items-center gap-2 mt-1">
                            <Text copyable strong>{award.winning_ticket_id ?? award.winning_ticket_auto_id ?? '—'}</Text>
                        </div>
                    </div>


                    {award.app_user && <div className="mt-4">
                        <Text type="secondary">Usuário:</Text>
                        <div className="flex items-center gap-3 mt-2">
                            <div>
                                <div><Text strong>{award.app_user.name ?? '—'}</Text></div>
                                {formatCpf(award.app_user.cpf) && <div><Text type="secondary">{formatPhone(award.app_user.phone)}</Text></div>}
                            </div>
                        </div>
                        <Button type="primary" style={{ marginTop: 10, backgroundColor: "#328E6E" }} onClick={() => navigate('/usuarios/aplicativo/visualizar/' + award.app_user?.id)} icon={<FaUser />}>Ver usuário</Button>
                    </div>}

                    {award.app_user_auto && !award.app_user && <div className="mt-4">
                        <Text type="secondary">Usuário:</Text>
                        <div className="flex items-center gap-3 mt-2">
                            <div>
                                <div><Text strong>{award.app_user_auto.name ?? '—'}</Text></div>
                                {formatCpf(award.app_user_auto.cpfCnpj)}
                            </div>
                        </div>
                    </div>}
                </Col>
            </Row>
        </div>)
    }, [award, navigate]);


    const rightCol = useCallback(() => {
        return (
            <div className="p-4" style={{ maxHeight: 500, overflowY: 'auto', marginRight: 14 }}>
                <Title level={5} style={{ marginBottom: 15 }}>Histórico do prêmio</Title>


                {award.award_history && award.award_history.length > 0 ? (
                    <Timeline>
                        {[...award.award_history].reverse().map((h) => (
                            <Timeline.Item key={h.id} >
                                <div className="flex justify-between">
                                    <div>
                                        <Text strong>{h.status}</Text>
                                        {h.observation && <div className="mt-1"><Text>{h.observation}</Text></div>}
                                        <div className="mt-1"><Text type="secondary">{h.attempt_number}° Tentativa</Text></div>
                                    </div>
                                    <div className="text-right">
                                        <Text type="secondary">{new Date(h.created_at).toLocaleString()}</Text>
                                    </div>
                                </div>
                            </Timeline.Item>
                        ))}
                    </Timeline>
                ) : (
                    <div className="mt-6 text-center">
                        <Text type="secondary">Nenhum histórico encontrado.</Text>
                    </div>
                )}
            </div>
        )
    }, [award]);

    return (
        <Modal
            title={null}
            open={visible}
            onCancel={onClose}
            cancelText={"Fechar"}
            okButtonProps={{
                hidden: true
            }}
            width={900}
        >
            <div className="flex">
                <div className="w-1/2 border-r border-gray-200">{leftCol()}</div>
                <div className="w-1/2">{rightCol()}</div>
            </div>
        </Modal>
    );
}
